import React from 'react'

import { IMaskInput } from 'react-imask'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'

type InputCepProps = FieldProps & {
  id?: string
  className?: string
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  onChange?: (value: string) => void
}

export const InputCep = ({
  name,
  label,
  className,
  container,
  error,
  onChange,
  withoutError = false,
  ...rest
}: InputCepProps) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <div {...container}>
      {label}
      <IMaskInput
        mask="00000-000"
        value={field.value}
        onAccept={(value: string) => {
          const cleanValue = value.replace(/_/g, '')
          helpers.setValue(cleanValue)
          if (onChange) {
            onChange(cleanValue)
          }
        }}
        onBlur={() => helpers.setTouched(true)}
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
